module.exports = __webpack_public_path__ + "static/img/d-rulebg.98fbbf8b.png";